import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {Banner, BannerTypesEnum} from '../../../common/banners/banner';
import {BannerAction} from '../../../common/banners/bannerAction';
import {BannerCloseAction} from '../../../common/banners/bannerCloseAction';
import {BannerContent} from '../../../common/banners/bannerContent';
import {BannerContentTitle} from '../../../common/banners/bannerContentTitle';
import {BannerFooterActions} from '../../../common/banners/bannerFooterActions';
import {BannerIcon} from '../../../common/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../common/banners/bannersContext';

/*
 * Props.
 */

interface ImpersonationRequestBannerProps {
  onAllowClick: Handler;
  onDenyClick: Handler;
}

/*
 * Component.
 */

export const ImpersonationRequestBanner: FC<ImpersonationRequestBannerProps> = (props) => {
  const theme = useUserTheme();
  const {onAllowClick, onDenyClick} = props;

  const requesterNameRender = <Trans id="impersonation-request-frontsupport">Front Support</Trans>;

  return (
    <Banner
      bannerType={BannerTypesEnum.MULTILINE}
      color={theme.palette.green.shade40}
      priority={BannerPrioritiesEnum.INFORMATION}
    >
      <BannerCloseAction onClick={onDenyClick} />
      <BannerIcon iconName="assignFilledSmall" />
      <BannerContent>
        <BannerContentTitle>
          <Trans id="impersonation-request-title">Support request</Trans>
        </BannerContentTitle>
        <Trans id="impersonation-request-text">
          Would you like to grant support access to {requesterNameRender}?
        </Trans>
      </BannerContent>
      <BannerFooterActions>
        <BannerAction onClick={onAllowClick}>
          <Trans id="impersonation-request-allow">Allow</Trans>
        </BannerAction>
        <BannerAction onClick={onDenyClick}>
          <Trans id="impersonation-request-deny">Deny</Trans>
        </BannerAction>
      </BannerFooterActions>
    </Banner>
  );
};
